<div *ngIf="message" class="alert" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-warning': message.type == 'warning', 'alert-info': message.type == 'info' }" (dblclick)="onClose()">
  <div class="message">
    {{message.text}}
    <span *ngFor="let m of message.texts">{{ m }}<br></span>
  </div>
  <button type="button" class="btn" (click)="onClose()"><i class="material-icons">close</i></button>
</div>
